export default "__VITE_ASSET__D_c_yzNg__"